import { textFormatButtons } from '../../design/textFormatButtons'
import { useTextSelection } from './useTextSelection'
import { QBtn, QSep } from './quickToolbarParts'

/**
 * Форматирование текста в быстрой панели — только когда в тексте на холсте ЕСТЬ
 * выделение: без него кнопкам нечего красить. Слушает изменения выделения
 * редактора, иначе не узнало бы о нём. `mousedown` с `preventDefault`: клик по
 * кнопке не уводит фокус и выделение из текста.
 */
export const QuickTextFormat = ({ separated = true }: { separated?: boolean }) => {
  const { editor, hasSelection } = useTextSelection()
  if (!editor || !hasSelection) return null
  return (
    <>
      {separated ? <QSep /> : null}
      {textFormatButtons(editor).map(({ icon: Icon, label, run, active }) => (
        <span
          key={label}
          onMouseDown={(e) => {
            e.preventDefault()
            e.stopPropagation()
            run()
          }}
        >
          <QBtn title={label} active={active} onClick={() => {}}>
            <Icon className="size-4" />
          </QBtn>
        </span>
      ))}
    </>
  )
}
